import withStyles from '@mui/styles/withStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const UnCheckedIcon = withStyles(theme => ({
  checkIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
  },
}))(({ classes }: any) => (
  <CheckBoxOutlineBlankIcon className={classes.checkIcon} />
));

export default UnCheckedIcon;
